import { useMemo } from 'react';

import filter from 'lodash/filter';

import {
  BaseSchedulesResponseType,
  OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest,
  useOpeningTemplateBaseSchedulesGet,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

function formatBaseScheduleLabel(item: BaseSchedulesResponseType) {
  const { shiftName, subShiftName } = item;
  return `${shiftName} (${subShiftName})`;
}

const useOpeningTemplateBaseSchedulesOptionsGet = ({
  facilityId,
  departmentId,
  positionId,
  shiftTypeId,
}: OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest & {
  shiftTypeId?: number;
}) => {
  const {
    data = [],
    isLoading,
    isSuccess,
  } = useOpeningTemplateBaseSchedulesGet({
    facilityId,
    departmentId,
    positionId,
  });

  const options = useMemo(
    () =>
      filter(data, (schedule) => schedule.shiftID === shiftTypeId).map(
        (item) => ({
          id: String(item.baseScheduleID),
          label: formatBaseScheduleLabel(item),
          value: item.baseScheduleID as number,
          meta: item,
        })
      ),
    [data, shiftTypeId]
  );
  return { options, isLoading, isSuccess };
};

const dataFetcher = useOpeningTemplateBaseSchedulesOptionsGet;
type ExtraParameters = Parameters<typeof dataFetcher>[0];
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({
  facilityId: props.facilityId,
  departmentId: props.departmentId,
  positionId: props.positionId,
  shiftTypeId: props.shiftTypeId,
});

export const {
  BaseScheduleSelectField,
  BaseScheduleFormSelectField,
  BaseScheduleDataGridSelectField,
  BaseScheduleIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'BaseSchedule',
  useOptionsHook: dataFetcher,
  extractHookParams: hookParamsGetter,
});
